module.exports = __webpack_public_path__ + "static/twitter-f4dbcf739f180f108376bc8da9e45bdc.png";